import { defineStore } from 'pinia'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { GlobalError } from '@/utils/globalError/globalError'
import type {
  AerialArea,
  GetAerialAreaRequest
} from '@/types/api/geoAerialPhoto/geoAerialPhotoTypes'
import { geoAerialPhotoApi } from '@/api/geoAerialPhoto/geoAerialPhotoApiGwFuncs'

// State 用 TypeScript 型定義
interface AerialAreasState {
  /** 空撮範囲 */
  aerialAreas: AerialArea[] | undefined
}

const initialState: AerialAreasState = {
  aerialAreas: []
}

// Pinia Store の定義
export const useAerialAreasStore = defineStore('aerialAreas', {
  state: (): AerialAreasState => ({ ...initialState }),

  getters: {
    /**
     * State全体を取得
     */
    getAerialAreas(state): AerialAreasState {
      return state
    },

    /**
     * すべてのパラメータが undefined でない場合 true を返す
     * 通常、APIで取得後はすべてのフィールドが定義されることを期待
     */
    hasData(state): boolean {
      return state.aerialAreas !== undefined
    }
  },

  actions: {
    /**
     * State をまとめて更新
     */
    updateState(obj: AerialAreasState) {
      this.aerialAreas = obj.aerialAreas
    },

    /**
     * State のすべての値を初期化
     */
    reset() {
      Object.assign(this.$state, initialState)
    },

    /**
     * APIからデータを取得
     */
    async fetch(params: GetAerialAreaRequest) {
      if (params.govCode === undefined || params.disasterId === undefined)
        throw new GlobalError([ERROR_CODES.GET_AERIAL_AREAS_FETCH_FAILED])
      const { getAerialArea } = geoAerialPhotoApi()
      const res = await getAerialArea(params)
      if (res.error !== undefined) {
        throw new GlobalError([ERROR_CODES.GET_AERIAL_AREAS_FETCH_FAILED])
      }
      if (res.result !== undefined) {
        this.updateState({
          aerialAreas: res.result.flightAreas
        })
      }
    }
  }
})
